import * as Yup from "yup";
import Banner from "../Banner";
import { useFormik } from "formik";
import { DONATEITEMS } from "utilities/data";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import WebLayout from "layout/webLayout.js";
import InputSelect from "shared/InputSelect";
import { useNavigate } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";

const ConnectProjectSelect = () => {
  const navigate = useNavigate();
  const [pickup, setPickup] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  const pickupOptions = [
    {
      title: "Pick-up",
      value: "pickup",
    },
  ];

  const formik = useFormik({
    initialValues: {
      items: selectedItems,
      delivery_method: pickup,
    },
    validationSchema: Yup.object({
      delivery_method: Yup.string().required("This field is Required"),
    }),
    onSubmit: (values) => {
      const body = {
        items: selectedItems,
        delivery_method: values.delivery_method,
      };
      if (selectedItems.length > 0) {
        let path = `/donate-items/category/${pickup}`;
        navigate(path, { state: body });
      } else {
        toast.error("Please select items to donate!");
        return;
      }
    },
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const onSelect = (selectedList, selectedItem) => {
    setSelectedItems([...selectedItems, selectedItem.item]);
  };

  const onRemove = (selectedList, selectedItem) => {
    setSelectedItems(
      selectedItems.filter((item) => item !== selectedItem.item)
    );
  };

  return (
    <WebLayout>
      <Banner />
      <div className="flex justify-center items-center">
        <div className="w-4/5 md:w-2/5 py-24 p-8 flex justify-center items-center">
          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-col gap-4 justify-center items-center">
              <p className="text-[#213874] text-[24px] font-bold text-center">
                TrueKeepers will connect you with projects who needs your
                donation
              </p>
              <p className="text-[#7A7A7A] text-[16px] text-center">
                Tell us about what you have to give. We match your gift in
                real-time with children in need and make giving easy for you.
              </p>
              <div className="w-full">
                <InputSelect
                  options={pickupOptions}
                  name="delivery_method"
                  onChange={(e) => {
                    setPickup(e.target.value);
                    formik.setValues({ delivery_method: e.target.value });
                  }}
                  optionsHolder="Would you like a pick-up?"
                  divClass="!rounded-3xl !border-[#213874]"
                  className="!rounded-3xl text-[#213874] !px-6"
                />
                {formik.touched.delivery_method &&
                formik.errors.delivery_method ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.delivery_method}
                  </p>
                ) : null}
              </div>
              <div className="w-full h-[41px] relative">
                <Multiselect
                  groupBy="title"
                  displayValue="item"
                  onSelect={onSelect}
                  onRemove={onRemove}
                  options={DONATEITEMS}
                  value={selectedItems}
                  placeholder={"Select items"}
                  className="w-full h-[41px] text-[#213874]"
                />
                <div className="absolute inset-y-0 right-0 flex items-center px-2 top-[2px] pointer-events-none">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.4391 6.63501H8.76658H4.55908C3.83908 6.63501 3.47908 7.50501 3.98908 8.01501L7.87408 11.9C8.49658 12.5225 9.50908 12.5225 10.1316 11.9L11.6091 10.4225L14.0166 8.01501C14.5191 7.50501 14.1591 6.63501 13.4391 6.63501Z"
                      fill="#F0CA18"
                    />
                  </svg>
                </div>
              </div>
              <button className="w-full" type="submit">
                <p className="w-full flex justify-center items-center bg-[#213874] hover:bg-[#192b5b] py-3 px-8 h-[50px] rounded-3xl text-white">
                  Continue
                </p>
              </button>
            </div>
          </form>
        </div>
      </div>
    </WebLayout>
  );
};

export default ConnectProjectSelect;
